



































































import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import { Subscription } from '@/types/core-push';
import { curNfreshClient, NfreshClient } from '@/services/NfreshClient';
import NfreshSubRow from '@/components/nfresh/NfreshSubRow.vue'
import NfreshSubRowMobile from '@/components/nfresh/NfreshSubRowMobile.vue'
import NfreshCreateSub from '@/components/nfresh/NfreshCreateSub.vue';
import NfreshDeleteSub from '@/components/nfresh/NfreshDeleteSub.vue';

@Component({
  components: {
    NfreshDeleteSub,
    NfreshCreateSub,
    VueError,
    Loading,
    NfreshSubRow,
    NfreshSubRowMobile
  },
})
export default class NfreshSubs extends Vue {

  httpBusy = false;
  error = '';
  status:'view-all'|'create'|'edit'|'delete' = 'view-all';
  subList:Subscription[] = [];
  selectedSub:Subscription = {} as Subscription;

  private nfreshClient:NfreshClient = curNfreshClient;
  
  async mounted() {

    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'delete', selectedSub?:Subscription) {

    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedSub)
      this.selectedSub = selectedSub;
  }

  async refreshData() {

    this.httpBusy = true;
    this.subList = [];
    this.error = '';

    const reply = await this.nfreshClient.getSubscriptions({skip:0, limit:1000});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve subscription list: ${reply.errorMsg}`;

    this.subList = reply.subList as Subscription[];
  }

  get showSubscriptions():boolean {
    return !this.httpBusy;
  }

  get showLoading():boolean {
    return this.httpBusy;
  }

  get showNoSubscriptions():boolean {
    return this.subList.length === 0 && !this.httpBusy && this.error === '';
  }

  goToView(sub:Subscription) {
    // return this.$router.push({name:'subscription', params: { subId: `${sub.subscriptionId}` }});
    return this.$router.push(`subscriptions/${sub.subscriptionId}`);
  }

}
